import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=704d4e9d&scoped=true"
import script from "./Checkout.vue?vue&type=script&lang=ts"
export * from "./Checkout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d4e9d",
  null
  
)

export default component.exports